/** Keep 0 (Developing / Exhausted / Defend / Weakest). Default react-table equals drops falsy values. Hidden columns may omit row.values. */
const cellValue = (row, id) => {
  const fromValues = row?.values ? row.values[id] : undefined;
  if (fromValues !== undefined && fromValues !== null && fromValues !== '') {
    return fromValues;
  }
  return row?.original ? row.original[id] : undefined;
};

const sameFilterValue = (rowValue, filterValue) => {
  if (rowValue === filterValue) return true;
  if (String(rowValue) === String(filterValue)) return true;
  const left = Number(rowValue);
  const right = Number(filterValue);
  return Number.isFinite(left) && Number.isFinite(right) && left === right;
};

const exactValueFilter = (rows, columnIds, filterValue) => {
  if (filterValue === undefined || filterValue === null || filterValue === '') {
    return rows;
  }
  const ids = Array.isArray(columnIds) ? columnIds : [columnIds];
  return rows.filter((row) =>
    ids.some((id) => {
      const rowValue = cellValue(row, id);
      if (rowValue === undefined || rowValue === null || rowValue === '') {
        return false;
      }
      return sameFilterValue(rowValue, filterValue);
    })
  );
};
exactValueFilter.autoRemove = (val) =>
  val === undefined || val === null || val === '';

export default exactValueFilter;
